
import axios from "axios";

const BASE_URL = import.meta.env.VITE_REACT_APP_MY_SUPERB_TRIP_BACKEND_URL;

const instance = axios.create({
    baseURL: BASE_URL,

    // Lets keep a check as default is 0 millisecond i.e. never
    // Note: timeout is only for server response not network i.e. server reachability
    timeout: 100000,

    // Lets keep a check as default bytes- 2k
    maxContentLength: 1000,

    // Lets keep a check as default 5 seems high
    maxRedirects: 2,

});

instance.interceptors.request.use((req) => {
    return req;
});

instance.interceptors.request.use((config) => {
    // const token = localStorage.getItem("auth"); 
    const token = JSON.parse(localStorage.getItem(`tokenId`));
    if (token) {
        config.headers.Authorization = `${token}`;
    }
    
    // Rate limiting: only fire a request every 2 sec from lodash.debounce
    //return new Promise((resolve) => { debounce( () => resolve(config),2000); });
    return Promise.resolve(config);
}, function (error) {
    const response = handleLogError(error); // log them
    return Promise.reject(error);
}
    // multiple options as to when and how to apply these interceptors
    // , { synchronous: true, runWhen: onGetCall }
);



export default instance;